/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Event',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M7.857 14.385a1 1 0 0 1 1.339.068l2.501 2.501.067.076a1 1 0 0 1 0 1.262l-.067.076-2.501 2.5-.076.068a1 1 0 0 1-1.263 0l-.075-.068-2.5-2.5a1 1 0 0 1-.069-1.338l.069-.076 2.5-2.501.075-.068zm-1.585 3.276l2.217 2.217 2.218-2.217-2.218-2.218-2.217 2.218zm9.8-12.237c.277-.966 1.646-.966 1.923 0l.404 1.418a1 1 0 0 0 1.205.695l1.43-.358c.976-.244 1.661.943.962 1.666L20.97 9.904a1 1 0 0 0 0 1.392l1.025 1.059c.678.7.056 1.837-.871 1.685l-.091-.018-1.43-.358a1 1 0 0 0-1.205.695l-.404 1.418-.029.088c-.321.85-1.543.85-1.864 0l-.029-.088-.404-1.418a1 1 0 0 0-1.205-.695l-1.43.358-.091.018c-.927.152-1.549-.984-.871-1.685l1.025-1.059a1 1 0 0 0 .066-1.316l-.066-.075-1.025-1.059c-.699-.723-.014-1.911.962-1.666l1.43.358a1 1 0 0 0 1.173-.601l.032-.095.404-1.418zm.749 1.747a2.2 2.2 0 0 1-2.65 1.53l-.751-.188.539.557a2.2 2.2 0 0 1 0 3.06l-.539.556.751-.187.216-.043a2.2 2.2 0 0 1 2.364 1.364l.07.209.212.744.213-.744.07-.209a2.2 2.2 0 0 1 2.364-1.364l.216.043.75.188-.538-.556a2.2 2.2 0 0 1 0-3.06l.538-.557-.75.188a2.2 2.2 0 0 1-2.65-1.53l-.213-.745-.212.745zM4.982 3.491c.322-.87 1.553-.87 1.875 0l.546 1.475a1 1 0 0 0 .591.591l1.475.546c.87.322.87 1.553 0 1.875l-1.475.546a1 1 0 0 0-.591.591l-.546 1.475-.07.152c-.375.667-1.359.667-1.734 0l-.07-.152-.546-1.475a1 1 0 0 0-.591-.591l-1.475-.546c-.87-.322-.87-1.553 0-1.875l1.475-.546a1 1 0 0 0 .591-.591l.546-1.475zm.579 1.891a2.2 2.2 0 0 1-1.3 1.3l-.968.358.968.358a2.2 2.2 0 0 1 1.205 1.08l.095.22.358.967.358-.967.095-.22a2.2 2.2 0 0 1 1.205-1.08l.967-.358-.967-.358a2.2 2.2 0 0 1-1.3-1.3l-.358-.968-.358.968z" />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
